<script>
  import { fade } from "svelte/transition";
  import Textarea from "@components/Textarea";
  import { toggleActiveVideo } from "@components/Video";
  import { logButtonClick } from "@services/analytics";
  import { _ } from "@services/i18n";
  import { getIntent } from "@services/speakeasy";
  import {
    activeVideo,
    experience,
    response,
    textMode
  } from "@stores/global";
  import { FADE_DURATION, VIDEOS } from "../consts";

  let text;

  $: contexts = ($response && $response.contexts) || [];

  /**
   * Reset text to an empty string
   */
  function clearText() {
    text = "";
  }

  /**
   * If event triggered from enter key,
   * prevent default and fire submit
   *
   * @param {Event} event
   */
  function submitOnEnter(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      onSubmit();
    }
  }

  /**
   * Send text to /speak API
   */
  async function onSubmit() {
    logButtonClick("text_form_submit");

    if ($activeVideo === VIDEOS.CONVERSATION) {
      toggleActiveVideo().andPlay();
    }

    await getIntent({
      type: "text",
      payload: text,
      experienceId: $experience.id,
      onAfterSubmit: clearText,
      onError: clearText,
    });
  }
</script>

<style>
  form {
    align-items: center;
    display: flex;
    flex-direction: row;
  }

  :global(.enhanced) form {
    align-items: flex-end;
  }

  .submit {
    background: url("/images/send.svg") 0 0 no-repeat;
    background-size: 100%;
    border: 0;
    color: transparent;
    cursor: pointer;
    height: 4.8rem;
    margin: 0;
    overflow: hidden;
    pointer-events: auto;
    width: 4.8rem;
  }

  :global(.enhanced) .submit {
    bottom: 2.2rem;
    position: absolute;
    right: 1rem;
  }
</style>

<form
  method="post"
  action={`/experience/${$experience.id}`}
  on:submit|preventDefault
  transition:fade={{ duration: FADE_DURATION }}
>
  <input type="hidden" name="experienceId" value={$experience.id} />
  <input type="hidden" name="type" value="text" />
  {#each contexts as context, index}
    <input type="hidden" name={`contexts[${index}]`} value={encodeURIComponent(JSON.stringify(context))} />
  {/each}

  <Textarea bind:text on:keydown={submitOnEnter} />

  <button
    type="submit"
    class="submit"
    class:visible={$textMode}
    on:click|preventDefault={onSubmit}
  >
    {$_("components.form.button.text", { default: "Send" })}
  </button>
</form>
